import { zfUtils } from "./zf_utils";
import { zfc } from "./zfc_global";
export class zfcSeperator {
    static init() {
        try {
            zfcSeperator.headerWrapper = $(".zfch2-header2");
            zfcSeperator.headerSeperatorHolder = $(".zfch2-header2 .zfch2-header2-seperator-holder");
            if (!zfcSeperator.headerSeperatorHolder.length) {
                return;
            }
            zfcSeperator.stickySeperators = [];
            $(".zfc-separator.zfc-separator-sticky").each(function () {
                if (this.initialized) {
                    return;
                }
                var el = $(this);
                var clonedItem = el.clone();
                clonedItem.attr("id", "");
                zfcSeperator.headerSeperatorHolder.append(clonedItem);
                zfcSeperator.stickySeperators.push({
                    el: el,
                    clonedItem: clonedItem,
                    sticked: false,
                });
                this.initialized = true;
            });
            if (!zfcSeperator.scrolRegistered) {
                zfcSeperator.scrolRegistered = true;
                zfUtils.onScroll(function () {
                    var lastSeperator = null;
                    var offset = zfc.window.scrollTop() + zfcSeperator.headerWrapper.height();
                    zfcSeperator.stickySeperators.forEach(function (s) {
                        if (offset >= Math.floor(s.el.offset().top)) {
                            lastSeperator = s;
                        }
                    });
                    zfcSeperator.headerSeperatorHolder.children().removeClass("active");
                    if (lastSeperator) {
                        lastSeperator.clonedItem.addClass("active");
                    }
                });
            }
        }
        catch (err) {
            console.log("initalization failed: zfcSeperator.init() " + err.message);
        }
    }
}
zfcSeperator.scrolRegistered = false;
zfcSeperator.stickySeperators = [];
try {
    zfUtils.onReady(zfcSeperator.init);
}
catch (err) {
    console.log("initalization failed: zfcSeperator.init() " + err.message);
}
